import { render, staticRenderFns } from "./ServicesSearchList.vue?vue&type=template&id=18360610&"
import script from "./ServicesSearchList.vue?vue&type=script&lang=js&"
export * from "./ServicesSearchList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports